import { connectSession } from "./session";
import {
  CONTACT_EVENT_STATE_MAP,
  CONTACT_STATE_MAP,
  CHANNEL_TYPES,
  LOG_PREFIX,
} from "../../constants/constants";
import { formatCaseAttributes } from "../../utils";
import { changeAgentStateToAvailable } from "./agent";
import Emitter from "../../emitter";
import {
  API_CONTACT_EVENT_LOGGING,
  API_MILO_VOICEMAIL_CHANNEL_TRANSACTION,
  STATE_VOICEMAIL,
  STATE_MISSED_VOICEMAIL,
} from "../constants";
import { Voicemail } from "../models/voicemail";
import { clearCurrentVoicemailContact } from "../api/voicemail";
import storeRTK from "../../store/storeRTK";
import Player from "../../utils/audio/player";

const lp = LOG_PREFIX + "[handlers.voicemail.ts]: ";

export const voicemailPlayer = new Player({ type: "VOICEMAIL", loop: true });

const defaultValue = {
  self: {
    voicemail: {},
  },
  customer: {},
};

export function handleIncomingVoicemail(contact: any) {
  console.log(lp + " INCOMING voicemail contact: ", contact);
  updateVoicemailAndSend(CONTACT_EVENT_STATE_MAP.INCOMING, contact);
  return {
    contactId: contact.contactId || contact.getContactId(),
    eventType: CONTACT_EVENT_STATE_MAP.RINGING,
    channel: CHANNEL_TYPES.VOICEMAIL,
  };
}
export function handleConnectingVoicemail(contact: any) {
  console.log(lp + " CONNECTING voicemail contact: ", contact);
  updateVoicemailAndSend(CONTACT_EVENT_STATE_MAP.CONNECTING, contact);
}

export function handleAcceptedVoicemail(contact: any) {
  console.log(
    lp +
      " ACCEPTED Contact accepted by agent. Contact state is " +
      contact.getStatus().type,
    contact
  );
  updateVoicemailAndSend(CONTACT_EVENT_STATE_MAP.ACCEPTED, contact);
}
export function handleConnectedVoicemail(contact: any) {
  console.log(
    lp +
      " CONNECTED voicemail contact connected to agent. Contact state is " +
      contact.getStatus().type
  );
  updateVoicemailAndSend(CONTACT_EVENT_STATE_MAP.CONNECTED, contact);
  // Send message to Notification Manager to call contactEvent api
  Emitter.emit(API_CONTACT_EVENT_LOGGING, {
    chan: API_CONTACT_EVENT_LOGGING,
    body: {
      contactId: contact?.contactId || contact?.getContactId(),
      eventType: CONTACT_EVENT_STATE_MAP.ESTABLISHED,
      channel: CHANNEL_TYPES.VOICE,
    },
  });

  Emitter.emit(API_MILO_VOICEMAIL_CHANNEL_TRANSACTION, {
    body: {
      contactId: contact.contactId || contact.getContactId(),
    },
  });
}

export function handleRefreshVoicemail(contact: any) {
  console.log(lp + " REFRESH voicemail contact: ", contact);
  try {
    updateVoicemailAndSend(CONTACT_EVENT_STATE_MAP.REFRESH, contact);
  } catch (e) {
    handleEndedVoicemail(contact);
  }
}
export function handleMissedVoicemail(contact: any) {
  console.log(lp + " MISSED voicemail contact: ", contact);
  
  // Get customer information for the missed voicemail notification
  const customerEndpoint = contact.getActiveInitialConnection()?.getEndpoint();
  const customerAttributes = formatCaseAttributes(contact.getAttributes());
  const queueInfo = contact.getQueue();
  const agentConnection = contact.getAgentConnection();
  // Send message to Notification Manager to call contactEvent api
  Emitter.emit(API_CONTACT_EVENT_LOGGING, {
    chan: API_CONTACT_EVENT_LOGGING,
    body: {
      contactId: contact?.contactId || contact?.getContactId(),
      eventType: CONTACT_EVENT_STATE_MAP.MISSED,
      channel: CHANNEL_TYPES.VOICE,
    },
  });
  try {
  // Emit enhanced missed voicemail event for notifications
  Emitter.emit(STATE_MISSED_VOICEMAIL, {
    chan: STATE_MISSED_VOICEMAIL,
    body: {
      contactId: contact.contactId || contact.getContactId(),
      eventType: CONTACT_EVENT_STATE_MAP.MISSED,
      channel: CHANNEL_TYPES.VOICE,
      // Customer information
      customerName: customerAttributes?.FIRSTNAME + ' ' + customerAttributes?.LASTNAME || 
                  customerAttributes?.Customer_Display_Name || 
                  customerEndpoint?.name || 
                  'Unknown Customer',
      phoneNumber: customerEndpoint?.phoneNumber || 
                  customerAttributes?.Customer_ANI || 
                  customerAttributes?.Customer_Phone || 
                  'Unknown Number',
      // Queue information
      queueName: queueInfo?.name || 'Unknown Queue',
      queueId: queueInfo?.queueARN || null,
      // Contact details
      direction: contact.isInbound() ? 'INBOUND' : 'OUTBOUND',
      contactStartTime: agentConnection.getState().timestamp || new Date().toISOString(),
      missedAt: new Date().toISOString(),
      // Additional attributes that might be useful
      customerAttributes: customerAttributes,
      // Agent context
      agentId: agentConnection?.connectionId || null,
      // Contact duration (if available)
      contactDuration: (new Date().getTime() - new Date(agentConnection.getState().timestamp).getTime()) || 0,
      // Voicemail specific information
      voicemailDuration: customerAttributes?.Voicemail_Duration || 0,
      voicemailUrl: customerAttributes?.Voicemail_Url || null,
    },
  });
  } catch (error) {
    console.log(lp + "Error emitting STATE_MISSED_VOICEMAIL event", error);
  }
  // changeAgentStateToAvailable();
  clearCurrentVoicemailContact(contact.contactId || contact.getContactId());
  updateVoicemailAndSend(CONTACT_EVENT_STATE_MAP.MISSED, contact);
}

export function handleDestroyVoicemail(contact: any) {
  console.log(lp + " DESTROY voicemail contact: ", contact);
  updateVoicemailAndSend(CONTACT_EVENT_STATE_MAP.DESTROYED, contact);
  // Send message to Notification Manager to call contactEvent api
  Emitter.emit(API_CONTACT_EVENT_LOGGING, {
    chan: API_CONTACT_EVENT_LOGGING,
    body: {
      contactId: contact?.contactId || contact?.getContactId(),
      eventType: CONTACT_EVENT_STATE_MAP.RELEASED,
      channel: CHANNEL_TYPES.VOICE,
    },
  });
}
export function handleEndedVoicemail(contact: any) {
  console.log(
    lp +
      " ENDED voicemail contact has ended. Contact state is " +
      contact.getStatus().type
  );
  updateVoicemailAndSend(CONTACT_EVENT_STATE_MAP.ENDED, contact);
  // Send message to Notification Manager to call contactEvent api
  Emitter.emit(API_CONTACT_EVENT_LOGGING, {
    chan: API_CONTACT_EVENT_LOGGING,
    body: {
      contactId: contact?.contactId || contact?.getContactId(),
      eventType: CONTACT_EVENT_STATE_MAP.RELEASED,
      channel: CHANNEL_TYPES.VOICE,
    },
  });
  if (contact.getStatus().type === "error") {
    console.log(lp + "Error in voicemail contact", contact.getStatus().error);
  }
}

export function updateVoicemailAndSend(type: any, contact: any) {
  try {
    const vm = Object.assign({}, connectSession.getVoicemail());
    const updatedVm = updateVoicemail(type, contact);
    if (JSON.stringify(vm) === JSON.stringify(updatedVm)) return;
    connectSession.setVoicemail(updatedVm);
    Emitter.emit(STATE_VOICEMAIL, { body: updatedVm });
  } catch (error) {
    console.error(lp + "Error in updateVoicemailAndSend", error);
  }
}

function updateVoicemail(
  contactEventType: string,
  contact: any
): Voicemail | null {
  try {
    const vm = connectSession.getVoicemail() || { ...defaultValue };
    // needed as INITIAL/CONNECTING event overwrites the connectedTime on refresh
    const voicemailState = storeRTK.getState()?.callback;
    switch (contactEventType) {
      case CONTACT_EVENT_STATE_MAP.INITIAL:
        const voicemailAttributes = formatCaseAttributes(
          contact.getAttributes()
        );
        return {
          ...vm,
          id: contact.contactId || contact.getContactId(),
          selfState: CONTACT_STATE_MAP.INCOMING,
          conversationMedia: "VOICEMAIL",
          self: {
            ...vm.self,
            id: contact.getAgentConnection().getConnectionId(),
            userId: contact.getAgentConnection().getConnectionId(),
            queueId: contact.getAgentConnection().getConnectionId(),
            type: "AGENT",
            attributes: {},
            state: CONTACT_STATE_MAP.INCOMING,
            voicemail: {
              ...vm.self.voicemail,
              id: contact.contactId || contact.getContactId(),
              voicemailId: contact.contactId || contact.getContactId(),
              voicemailNumber: voicemailAttributes.PHONE_NUMBER,
              state: CONTACT_STATE_MAP.INCOMING,
              connectedTime:
                voicemailState?.self?.callback?.connectedTime || null,
              endTime: voicemailState?.self?.callback?.connectedTime || null,
            },
          },
          customer: {
            ...vm.customer,
            state: CONTACT_STATE_MAP.CONNECTED,
            attributes: voicemailAttributes,
            address: voicemailAttributes.PHONE_NUMBER,
            type: "CUSTOMER",
          },
        };

      case CONTACT_EVENT_STATE_MAP.CONNECTED:
        const resolvedConnectedTime =
          voicemailState?.self?.callback?.connectedTime || new Date().getTime();
        return {
          ...vm,
          selfState: CONTACT_STATE_MAP.CONNECTED,
          self: {
            ...vm.self,
            state: CONTACT_STATE_MAP.CONNECTED,
            connectedTime: resolvedConnectedTime,
            voicemail: {
              ...vm.self.voicemail,
              state: CONTACT_STATE_MAP.CONNECTED,
              connectedTime: resolvedConnectedTime,
            },
          },
        };

      case CONTACT_EVENT_STATE_MAP.MISSED:
        return {
          ...vm,
          self: {
            ...vm.self,
            missed: true,
          },
        };

      case CONTACT_EVENT_STATE_MAP.ENDED:
      case CONTACT_EVENT_STATE_MAP.DESTROYED:
        return {
          ...vm,
          self: {
            ...vm.self,
            state: CONTACT_STATE_MAP.ENDED,
            connectedTime:
              vm.self.voicemail.connectedTime || new Date().getTime(),
            endTime: vm.self.voicemail.endTime || new Date().getTime(),
            missed: [CONTACT_EVENT_STATE_MAP.REJECTED, CONTACT_EVENT_STATE_MAP.MISSED].includes(contact.getState()?.type?.toUpperCase()),
            voicemail: {
              ...vm.self.voicemail,
              state: CONTACT_STATE_MAP.ENDED,
              connectedTime:
                vm.self.voicemail.connectedTime || new Date().getTime(),
              endTime: vm.self.voicemail.endTime || new Date().getTime(),
            },
          },
        };
      default:
        return vm;
    }
  } catch (err) {
    console.log(
      lp +
        " Error in updating voicemail contactId: " +
        contact.getContactId() +
        err
    );
    return null;
  }
}
